import '../../App.css'

export function ModalMessage(props) {
    const styleTest = {
        display:'block'
    }

    const show = props.show
    if (show) {
        return <div class="modal fade show modal-overlay" id="modal-1" tabindex="-1" role="dialog" style={styleTest}>
                <div class="modal-dialog modal-dialog-centered" role="document">
                    <div class="modal-content">
                    <div class="modal-header">
                        <h1 class="modal-title fs-5" id="staticBackdropLabel">{props.title}</h1>
                        <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close" onClick={props.closeBtn}></button>
                    </div>
                    <div class="modal-body" style={{whiteSpace: 'pre-line'}}>
                        {props.msg}
                    </div>
                    <div class="modal-footer">
                        <button type="button" class="btn btn-secondary" data-bs-dismiss="modal" onClick={props.closeBtn}>아니요</button>
                        <button type="button" class="btn btn-primary" onClick={props.submitBtn}>네</button>
                    </div>
                    </div>
                </div>
            </div>
        
    }
    return "";
}

export function ModalNickname(props) {
    const styleTest = {
        display:'block'
    }

    function handleChangeNickname(event){
        props.setNicknameModi(event.target.value)
        props.setValidatedNickname(false)
        props.setMessageChangeNickname("")
        props.setEnableChangeNickname(false)
    }

    const show = props.show
    const classnameNickname = !props.validatedNickname ? "form-control" : props.enableChangeNickname ? "form-control is-valid" : "form-control is-invalid"
    if (show) {
        return <div class="modal fade show" id="modal-1" tabindex="-1" role="dialog" style={styleTest}>
                <div class="modal-dialog modal-dialog-centered" role="document">
                    <div class="modal-content">
                    <div class="modal-header">
                        <h1 class="modal-title fs-5" id="staticBackdropLabel">{props.title}</h1>
                        <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close" onClick={props.closeBtn}></button>
                    </div>
                    <div class="modal-body">
                        <form style={{marginTop: '10px'}}>
                            <div class="form-check">
                                <div class="input-group">
                                    <input type="text" class={classnameNickname} aria-describedby="basic-addon2" onChange={handleChangeNickname} value={props.nickname}/>
                                    <div class="input-group-append">
                                        <button class="btn btn-outline-primary" type="button" style={{marginLeft:'5px'}} onClick={props.createNickname}>자동생성</button>
                                        <button class="btn btn-outline-dark" type="button" style={{marginLeft:'5px'}} onClick={props.validateNickname}>중복확인</button>
                                    </div>
                                </div>
                                <div class="row">
                                    <label class="form-label"><span style={{marginLeft:"5px", fontSize: '13px'}}>{props.messageChangeNickname}</span></label>
                                </div>
                            </div>
                        </form>
                    </div>
                    <div class="modal-footer">
                        <button type="button" class="btn btn-secondary" data-bs-dismiss="modal" onClick={props.closeBtn}>아니요</button>
                        <button type="button" class="btn btn-primary" onClick={props.submitBtn} disabled={!props.enableChangeNickname}>네</button>
                    </div>
                    </div>
                </div>
            </div>
    }
    return "";
}

// export function ModalLogin(props) {
    
//     function submitModalLoginBtn(){
//         setShowModalLogin(false)
//         setRedirect(true)
//     }

//     function clickModalLoginBtn(){
//         setShowModalLogin(true)
//     }

//     function closeModalDeleteBtn(){
//         setShowModalDelete(false)
//     }

//     return <ModalMessage show={showModalLogin} closeBtn={closeModalLoginBtn} submitBtn={submitModalLoginBtn} title={"로그인이 필요합니다."} msg={"로그인 페이지로 안내해 드릴까요?"} />
// }
